var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transform text"},[_c('p',[_vm._v(_vm._s(_vm.transInfo.trans_result.dst))]),_vm._v(" "),_c('span',[_c('a-icon',{attrs:{"type":"check-circle","theme":"filled"}}),_vm._v(" 翻译成功")],1)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }